// extracted by mini-css-extract-plugin
module.exports = {"header":"CartManager_header_2klCA","body":"CartManager_body_nNHla","footer":"CartManager_footer_l2F6D","element":"CartManager_element_3nxSl"};